import React from "react";
import RichTextArea from "./forms/RichTextArea";
import Button from "./Button";
import { MinusIcon } from "@heroicons/react/16/solid";

const RecipeInstructions = ({ instructions, onUpdate, isSaving, errors }) => {

  const updateInstruction = (index, field, value) => {
    const updatedInstructions = instructions.map((instruction, i) =>
      i === index ? { ...instruction, [field]: value } : instruction
    )
    onUpdate("instructions", updatedInstructions)
  }

  const addInstruction = () => {
    const newInstruction = { text: "" };
    onUpdate("instructions", [...instructions, newInstruction]);
  }

  const deleteInstruction = (index) => {
    const updatedInstructions = instructions.filter((_, i) => i !== index)

    onUpdate("instructions", updatedInstructions)
  }

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Instructions</h2>
      <p className="text-sm text-gray-500 mb-3">Use the formatting buttons to add bold or italic emphasis.</p>
      <ul className="list-inside">
        {instructions.map((instruction, index) => (
          <li className="mb-4" key={index}>
            <div className="flex items-center">
              <div className="bold font-bold pr-2">{index + 1}.</div>
              <RichTextArea
                value={instruction.text}
                onChange={(value) => updateInstruction(index, "text", value)}
                className="w-full"
                rows="4"
                containerClassName="mr-2"
                error={errors?.[`${index}`]}
                showError="true"
                fullWidth="true"
                disabled={isSaving}
              />
            {index > 0 &&
                <Button type="gray" onClick={() => deleteInstruction(index)} className="px-1 py-1" disabled={isSaving}>
                  <MinusIcon className="size-4" />
                </Button>
              }
            </div>
          </li>
        ))}
      </ul>
      <Button type="secondary" onClick={addInstruction}>Add Instruction</Button>
    </div>
  )
}

export default RecipeInstructions;